export default __webpack_public_path__ + "static/media/lenco-logo.68db3dae.png";